import React from "react";

import { RecordType } from "../../../../../common/types/RecordType";
import { useCloudFileDetails } from "../../common/useCloudFileDetails";
import { AudioCloudFileTechnicalSection } from "./audio/AudioCloudFileTechnicalSection";
import { VideoCloudFileTechnicalSection } from "./video/VideoCloudFileTechnicalSection";

export const CloudFileTechnicalSection = (): JSX.Element => {
    const { data: cloudFileDetails, isLoading } = useCloudFileDetails();

    switch (cloudFileDetails?.recordType) {
        case RecordType.Video:
            return cloudFileDetails.videoTechnical ? (
                <VideoCloudFileTechnicalSection
                    videoTechnical={cloudFileDetails.videoTechnical}
                    isLoading={isLoading}
                />
            ) : (
                <></>
            );

        case RecordType.Audio:
            return cloudFileDetails.audioTechnical ? (
                <AudioCloudFileTechnicalSection
                    audioTechnical={cloudFileDetails.audioTechnical}
                    isLoading={isLoading}
                />
            ) : (
                <></>
            );

        case RecordType.Subtitle:
        default:
            return <></>;
    }
};
